module.exports = __webpack_public_path__ + "static/media/author.b6a6d167.md";